import { PaginationProps } from 'types';

export const handlePagination = (params?: PaginationProps): PaginationProps => {
  let localOffset = Number((params.currentPage - 1) * params.paginationLimit);
  if (params?.offset !== undefined) localOffset = params?.offset;
  return {
    ...params,
    limit: params?.limit || params.paginationLimit,
    offset: localOffset,
  };
};

export const decodeBase64Url = (value: string): string => {
  const base64UrlCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
  const bytes: number[] = [];
  let bitBuffer = 0;
  let bitCount = 0;

  for (let index = 0; index < value.length; index += 1) {
    const character = value[index];
    if (character === '=') break;

    const characterIndex = base64UrlCharacters.indexOf(character);
    if (characterIndex === -1) throw new Error('Invalid base64url value');

    bitBuffer = (bitBuffer << 6) | characterIndex;
    bitCount += 6;

    if (bitCount >= 8) {
      bitCount -= 8;
      bytes.push((bitBuffer >> bitCount) & 0xff);
    }
  }

  return new TextDecoder().decode(new Uint8Array(bytes));
};
